export const COUNTRY_LIST = [
  { label: "Australia", value: "au" },
  { label: "New Zealand", value: "nz" },
];